import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.css']
})
export class LoadingSpinnerComponent implements OnInit {

  @Input() width: number = 40;
  @Input() height: number = 40;
  @Input() alt: string;

  get viewBoxString(){
    return '0 0 ' + this.width + ' ' + this.height;
  }

  constructor() { }
 
  ngOnInit(): void {
  }

}
